import styled from "styled-components";
import theme from "../../theme/theme";

export const MainHeader = styled.h1`
  color: ${theme.color.navy};
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0;

  @media (max-width: 400px) {
    font-size: 2rem;
  }
`;

export const HeaderContainer = styled.div`
  margin-left: 10%;
  width: 80%;

  @media (max-width: 400px) {
    margin-left: 7%;
    margin-top: 30px;
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  margin: 15px 0 30px 10%;
  flex-wrap: wrap;
  gap: 15px;

  @media (max-width: 400px) {
    margin: 15px 0 30px 7%;
  }
`;

export const ButtonContainer = styled.div`
  margin-right: 5px;
  display: flex;
`;

export const CardSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  grid-gap: 20px;
  width: 90%;
  margin: 20px auto;
  align-items: flex-start;
  // margin-top: 235px;

  @media (min-width: 280px) {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }

  @media (max-width: 1300px) {
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  }
`;

export const ResourceCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;
